import React from "react";
import { Link } from "react-router-dom";
import "../CSS/PersonalService.css";

const PersonalService = () => {
  return (
    <section className="personal-apostille-page">
      <div className="personal-apostille-banner">
        <h1 className="personal-apostille-banner-title">
          Personal Document Apostille Service
        </h1>
        <p className="personal-apostille-breadcrumb">
          <Link to="/">Home</Link> &gt;
          <span> Personal Document Apostille Service</span>
        </p>
      </div>

      <div className="personal-apostille-layout">
        <aside className="personal-apostille-sidebar">
          <div className="personal-apostille-sidebox">
            <h3 className="personal-apostille-sidebox-title">
              APOSTILLE SERVICES
            </h3>
            <ul className="personal-apostille-side-list">
              <li className="personal-apostille-side-item">
                Educational Document Apostille
              </li>
              <li className="personal-apostille-side-item">
                Personal Document Apostille
              </li>
              <li className="personal-apostille-side-item">
                Commercial Document Apostille
              </li>
            </ul>
          </div>

          <div className="personal-apostille-sidebox">
            <h3 className="personal-apostille-sidebox-title">QUICK LINKS</h3>
            <ul className="personal-apostille-side-list">
              <li className="personal-apostille-side-item">
                Apostille Services in Mumbai
              </li>
              <li className="personal-apostille-side-item">
                Document Apostille Process
              </li>
              <li className="personal-apostille-side-item">
                MEA Approved Universities
              </li>
              <li className="personal-apostille-side-item">
                Apostille Country List
              </li>
              <li className="personal-apostille-side-item">
                Non Apostille Country List
              </li>
              <li className="personal-apostille-side-item">
                Apostille Accepted Embassy List
              </li>
              <li className="personal-apostille-side-item">
                Apostille Member Countries
              </li>
              <li className="personal-apostille-side-item">
                Apostille Centers – Mumbai
              </li>
            </ul>
          </div>
        </aside>

        <main className="personal-apostille-content">
          <h2 className="personal-apostille-main-title">
            Personal / Private Document Apostille Services in Mumbai
          </h2>

          <p className="personal-apostille-text">
            Personal document apostille is required when individuals need their
            documents to be legally recognized in foreign countries.
            Apostille.net.in provides reliable{" "}
            <strong>personal document apostille services in Mumbai</strong> for
            visa processing, immigration, employment, and family visa purposes.
          </p>

          <p className="personal-apostille-text">
            The Ministry of External Affairs (MEA) issues apostille certificates
            for documents that are required in countries that are members of the
            Hague Apostille Convention.
          </p>

          <h3 className="personal-apostille-section-title">
            Personal Documents We Apostille
          </h3>

          <ul className="personal-apostille-list">
            <li>Birth Certificate Apostille</li>
            <li>Marriage Certificate Apostille</li>
            <li>Police Clearance Certificate (PCC)</li>
            <li>Medical Certificate Apostille</li>
            <li>Affidavit Apostille</li>
            <li>Transfer Certificate Apostille</li>
          </ul>

          <h3 className="personal-apostille-section-title">
            Why Personal Document Apostille is Required
          </h3>

          <p className="personal-apostille-text">
            Personal or non-educational documents require authentication from
            the Ministry of External Affairs when travelling abroad. Document
            legalization is usually required for spouse visa, family visa,
            immigration, and overseas residency applications.
          </p>

          <p className="personal-apostille-text">
            For example, if you are applying for a spouse visa, your{" "}
            <strong>marriage certificate must be apostilled</strong> before
            submission to the embassy.
          </p>

          <h3 className="personal-apostille-section-title">
            How To Authenticate Documents For Apostille
          </h3>

          <p className="personal-apostille-text">
            Our apostille consultants handle the complete document
            authentication process including verification, state authentication,
            and final apostille from the MEA.
          </p>

          <p className="personal-apostille-text">
            We also provide convenient document collection and delivery services
            across Mumbai to make the process simple and hassle-free for
            clients.
          </p>

          <h3 className="personal-apostille-section-title">
            MEA Apostille Process
          </h3>

          <p className="personal-apostille-text">
            The apostille process generally involves multiple steps. First, the
            document is verified by the issuing authority. Then it is
            authenticated by the relevant State Government department such as
            the Home Department or GAD.
          </p>

          <p className="personal-apostille-text">
            After successful verification, the document is submitted to the{" "}
            <strong>Ministry of External Affairs (MEA)</strong> where the final
            apostille stamp is issued.
          </p>

          <h2 className="personal-apostille-main-title">Document Apostille</h2>

          <p className="personal-apostille-text">
            Please find the list of non-educational documents that can be
            apostilled. If your desired document is not listed, contact us
            directly at +91-8589 008 001 / +91-8588 808 183.
          </p>

          <h3 className="personal-apostille-section-title">
            Birth Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Birth certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A birth certificate issued by the State Government, UT, Village or
            Panchayat is eligible for apostille attestation. Normally it takes
            2-3 working days for authentication and apostille stamping.
          </p>

          <h3 className="personal-apostille-section-title">
            Marriage Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Marriage certificate <br />
                  2. Passport copy of Husband & Wife
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Marriage certificates issued by state authorities or marriage
            registration offices are eligible for apostille attestation. The
            process usually takes 2-3 working days.
          </p>

          <h3 className="personal-apostille-section-title">
            Death Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Death certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Death certificates issued by government authorities or municipal
            corporations are eligible for apostille attestation. Authentication
            generally takes 2-3 working days.
          </p>

          <h3 className="personal-apostille-section-title">
            Affidavits Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Affidavit <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <h3 className="personal-apostille-section-title">
            Driving License Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original driving license <br />
                  2. A Xerox copy of license <br />
                  3. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A driving license issued by the state government or UT is eligible
            for apostille attestation. Candidates need to provide the original
            driving license along with a xerox copy and passport copy.
            Normally it takes 2-3 working days for apostille authentication.
          </p>

          <h3 className="personal-apostille-section-title">
            Power Of Attorney Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original power of attorney <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A power of attorney issued by the state government or UT is
            eligible for apostille attestation. The candidate must submit the
            original POA document for apostille processing.
          </p>

          <h3 className="personal-apostille-section-title">
            School Leaving Certificate / Transfer Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. School leaving certificate / transfer certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Transfer certificate or school leaving certificate issued by
            schools, universities or educational institutions are eligible for
            apostille attestation. Authentication normally takes 2-3 working
            days.
          </p>

          <h3 className="personal-apostille-section-title">
            Police Clearance Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original PCC / Character certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Police clearance certificate issued by Passport Seva Kendra or
            state police department is eligible for apostille attestation. The
            candidate must submit the original PCC document for apostille
            processing.
          </p>

          <h3 className="personal-apostille-section-title">
            Registration Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Registration certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A registration certificate issued by the state government, UT,
            Village/Panchayat, MCA or MSME authority is eligible for apostille
            attestation. Candidates must submit the original certificate along
            with passport copy.
          </p>

          <h3 className="personal-apostille-section-title">
            Income Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Income certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            An income certificate issued by state government authorities or
            village/panchayat offices is eligible for apostille attestation.
            The process normally takes 2-3 working days.
          </p>

          <h3 className="personal-apostille-section-title">
            Bank Statement Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Bank statement <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Bank statements issued by RBI regulated banks, co-operative banks
            or financial institutions are eligible for apostille attestation.
          </p>

          <h3 className="personal-apostille-section-title">
            Bonafide Certificate Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Bonafide certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A bonafide certificate issued by schools, universities or
            educational institutions is eligible for apostille attestation.
            Authentication usually takes 2-3 working days.
          </p>

          <h3 className="personal-apostille-section-title">
            Identity Card Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original Identity card <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            An identity card issued by educational institutions, state
            government, union ministry or any Indian company registered in
            India is eligible for apostille attestation. Candidates must
            provide the original ID card along with a passport copy.
          </p>

          <h3 className="personal-apostille-section-title">
            Single Standing Apostille / Bachelor Hood Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Single standing certificate <br />
                  2. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            A single standing or bachelorhood certificate issued by state
            government authorities or through affidavit is eligible for
            apostille attestation. The process normally takes 2-3 working days.
          </p>

          <h3 className="personal-apostille-section-title">
            Passport Copy Apostille
          </h3>
          <table className="personal-apostille-table">
            <tbody>
              <tr>
                <td><strong>Document Checklist</strong></td>
                <td>
                  1. Original passport <br />
                  2. A photocopy of passport <br />
                  3. Passport copy
                </td>
              </tr>
              <tr>
                <td><strong>Processing Time</strong></td>
                <td>2-3 Working days</td>
              </tr>
            </tbody>
          </table>

          <p className="personal-apostille-text">
            Passports issued by Passport Seva Kendra are eligible for apostille
            attestation. Candidates must submit passport copy and supporting
            documents for processing.
          </p>
        </main>
      </div>
    </section>
  );
};

export default PersonalService;
